import {Controller} from "@hotwired/stimulus"
import { skeletonMessage } from "../helpers/dom_helpers"

const csrfToken = document.getElementsByName("csrf-token")[0].content;

export default class MessageController extends Controller {
    static values = { senderId: Number }

    connect() {
        const messageChatBox = this.element.parentElement.classList.contains('chat-text-content')
        if (messageChatBox) {
            const currentUser = document.getElementById('message').dataset.currentUserId
            const isSender = Number.parseInt(currentUser, 10) === this.senderIdValue;

            const messageBoxHolder = this.element.closest('.message-box-holder');
            const leftShapeBox = $(this.element)?.parent()?.parent()?.children()[0];

            messageBoxHolder?.classList.toggle('align-items-end', isSender);
            messageBoxHolder?.classList.toggle('align-items-start', !isSender);
            leftShapeBox?.classList.toggle('left-shape-box', !isSender);

            this.element.querySelectorAll('.sender-only').forEach(element => {
                element.classList.toggle('d-none', !isSender);
            });

            this.element.querySelectorAll('.receiver-only').forEach(element => {
                element.classList.toggle('d-none', isSender);
            });
        }
    }

    updateMessageSetting(event) {
        const form = event.target.closest('form')
        if (!form) return

        const ALL_ID = 'is_all'
        const FILTER_IDS = ['is_hero', 'is_follower', 'is_nemeses', 'is_mention']

        const changedCheckbox = event.target
        const { id: changedId, checked: isChecked } = changedCheckbox

        // If "All" is selected, uncheck every specific filter
        if (changedId === ALL_ID && isChecked) {
            FILTER_IDS.forEach((id) => {
                const checkbox = form.querySelector(`#${id}`)
                if (checkbox) checkbox.checked = false
            })
        }

        // If any specific filter is selected, uncheck "All"
        if (FILTER_IDS.includes(changedId) && isChecked) {
            const allCheckbox = form.querySelector(`#${ALL_ID}`)
            if (allCheckbox) allCheckbox.checked = false
        }

        form.requestSubmit()
    }

    selectConversation(e) {
        if (!$(e.target)?.closest('.room-user')[0]?.classList?.contains('active')) {
            // update the window location URL when open the chat from search action
            const roomId = new URL(e.currentTarget.href).searchParams.get("room_id")
            if (roomId) {
                globalThis.history.replaceState({}, "", `/messages/${roomId}`)
            }
            let field = $('.room-user').not($(e.target).closest('.room-user'))
            $(e.target).closest('.room-user').addClass('active')
            $(e.target).closest('.room-user').addClass('disabled-link')
            field.removeClass('active')
            field.removeClass('disabled-link')
            $("#chat-area").html(skeletonMessage());
            if (globalThis.innerWidth < 512) {
                $('#user-list').addClass('d-none');
                $("#chat-area").removeClass('d-none');
                $("#header-back-btn").addClass('d-none');
            }
        }
    }

    forwardMsg(e){
        let value = $(e.target).val()
        let hiddenInput = $('input[type=hidden][id=message_value]');
        hiddenInput.attr('value', value)
    }

    reportConversation(e){
        this.url = globalThis.location.href.split('?')[0];
        globalThis.history.replaceState({}, null, this.url);
    }

    muteConversation(e){
        e.preventDefault()
        let value = $(e.target).attr('data-value')
        let id = $(e.target).attr('data-id')
        fetch('/rooms/'+ id + '/mute?mute_duration=' + value, {
            method: 'PUT',
            headers: {
                Accept: "text/vnd.turbo-stream.html",
                "X-CSRF-Token": csrfToken,
                'Content-Type': 'application/json'
            }
        }).then(r => r.text())
            .then(html => {
                let truck_modal = document.getElementById('mute_dialog_content').closest('#addFolder');
                const modalController = this.application.getControllerForElementAndIdentifier(truck_modal, "modal");
                modalController.closeModal();
                Turbo.renderStreamMessage(html)
            })
    }

    removeMessage() {
        this?.element?.closest("turbo-frame")?.remove();
    }
}
